<template>
  <Modal
    v-model="_value"
    width="500"
    title='锐明触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onSendDriverCardParams">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'

  export default {
    name: 'rmsettriggeralarmmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        //报警行为选项
        alarm:null,
        alarmOptions: [
          {name: '打电话', value: 2},
        ],
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),

      SendCommand(content){
        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content: content , urgent: false }
        }).then(() => {
          // this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onSendDriverCardParams () {
        // let content = '99admin,admin,SAAS56,'+this.alarm+'!'
        //
        // store.dispatch('NetCommandServ_SendCommand', {
        //   params: { id: this._initValue, content: content , urgent: false }
        // }).then(() => {
        //   this.$Message.success('发送成功')
        // }).catch(err => {
        //   this.$Message.error(err)
        // })

        this.SendCommand('99admin,admin,SAAS56,'+this.alarm+'!')

        setTimeout(() => {
            this.SendCommand('99admin,JC336699,SAAS56,'+this.alarm+'!')
          }
          , 2000)

        setTimeout(() => {
            this.SendCommand('99admin,,SAAS56,'+this.alarm+'!')
          }
          , 4000)

        this.$Message.success('发送成功')

      },
      onCleanDriverCardParams(){
        this.alarm = null
      },
      visibleChange(val) {
        if(val){
          this.alarm = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
